(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hiro-anmeldelser"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function start(rot) {
      rot.querySelectorAll('.hiro-anm__kort').forEach(function (kort) {
        var tekst = kort.querySelector('.hiro-anm__tekst');
        var knapp = kort.querySelector('.hiro-anm__mer');
        if (!tekst || !knapp) return;
        var sjekk = function () { knapp.hidden = kort.classList.contains('hiro-anm__kort--apen') ? false : tekst.scrollHeight <= tekst.clientHeight + 2; };
        sjekk();
        knapp.addEventListener('click', function () {
          var apen = kort.classList.toggle('hiro-anm__kort--apen');
          knapp.textContent = apen ? 'Vis mindre' : 'Les mer';
        });
      });
      var flere = rot.querySelector('.hiro-anm__flere');
      if (flere) {
        var liste = rot.querySelector('.hiro-anm__liste');
        var desktop = window.matchMedia('(min-width: 990px)');
        var skjulte = function () { return Array.prototype.filter.call(liste.querySelectorAll('.hiro-anm__kort'), function (k) { return getComputedStyle(k).display === 'none'; }); };
        var oppdater = function () { flere.hidden = skjulte().length === 0; };
        oppdater();
        desktop.addEventListener('change', oppdater);
        flere.addEventListener('click', function () {
          var steg = parseInt(liste.getAttribute(desktop.matches ? 'data-vis' : 'data-vis-mobil'), 10) || 3;
          var neste = skjulte().slice(0, steg);
          neste.forEach(function (k) { k.classList.remove('hiro-anm__kort--skjult', 'hiro-anm__kort--skjult-m'); });
          liste.querySelectorAll('.hiro-anm__kort').forEach(function (k) { var t = k.querySelector('.hiro-anm__tekst'), b = k.querySelector('.hiro-anm__mer'); if (t && b && !k.classList.contains('hiro-anm__kort--apen')) b.hidden = t.scrollHeight <= t.clientHeight + 2; });
          if (neste[0]) { neste[0].setAttribute('tabindex', '-1'); neste[0].focus({ preventScroll: true }); }
          oppdater();
        });
      }
    }
    document.querySelectorAll('.hiro-anm').forEach(start);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hiro-illustrert"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.querySelectorAll('.hiro-ill__video').forEach(function (v) { v.removeAttribute('autoplay'); v.pause(); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hiro-kunngjoring"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.hiro-kunngj__bytt').forEach(function (boks) {
      var meldinger = boks.querySelectorAll('.hiro-kunngj__melding');
      if (meldinger.length < 2 || boks.getAttribute('data-auto') !== 'true') return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var i = 0, ms = (parseInt(boks.getAttribute('data-bytte'), 10) || 6) * 1000;
      setInterval(function () {
        meldinger[i].classList.remove('er-aktiv');
        i = (i + 1) % meldinger.length;
        meldinger[i].classList.add('er-aktiv');
      }, ms);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hiro-sitater"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.hiro-sit').forEach(function (rot) {
      var knapp = rot.querySelector('.hiro-sit__flere');
      var liste = rot.querySelector('.hiro-sit__liste');
      if (!knapp || !liste) return;
      knapp.addEventListener('click', function () {
        var forste = liste.querySelector('.hiro-sit__kort--skjult-m');
        liste.classList.add('er-apen');
        knapp.parentNode.remove();
        if (forste) { forste.setAttribute('tabindex', '-1'); forste.focus({ preventScroll: true }); }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hiro-slik"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.querySelectorAll('video.hiro-slik__video').forEach(function (v) { v.removeAttribute('autoplay'); v.pause(); v.setAttribute('controls', ''); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
